import ChargeHelper from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddVehicleModelView from '../DialogAddVehicleModelView';

ChargeVehicleModelListView.propTypes = {
  showFullUI: PropTypes.bool,
  chargeVehicleBrandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function ChargeVehicleModelListView({ showFullUI = false, chargeVehicleBrandId }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const [chargeVehicleBrandDetail, setChargeVehicleBrandDetail] = useState(null);
  useEffect(() => {
    if (chargeVehicleBrandId) {
      ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({
        brandId: chargeVehicleBrandId,
      }).then((response) => {
        const brand = response.brands.find((item) => item.brandId == chargeVehicleBrandId);
        setChargeVehicleBrandDetail(brand);
      });
    }
  }, [chargeVehicleBrandId]);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeVehicleModelList);
  const [chargeVehicleModelList, setChargeVehicleModelList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    ChargeHelper.API.ChargeVehicleModel.requestGetChargeVehicleModelList(chargeVehicleBrandId, {
      ...filter,
    })
      .then((response) => {
        setChargeVehicleModelList(response?.models);
        setTotal(response?.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter, chargeVehicleBrandId]);
  const fullColumns = useMemo(() => {
    return [
      {
        name: UIHelper.buildTableColumn('Logo'),
        selector: (row) =>
          UIHelper.buildAvatar(Utils.getFullUrl(row?.image), 40, null, false, false),
        width: '70px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Mã dòng xe'),
        selector: (row) => row?.modelId,
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Tên dòng xe'),
        selector: (row) => row?.name,
        minWidth: '240px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Mô tả'),
        selector: (row) => {
          return (
            <KTTooltip text={row?.description}>
              <div className="my-2 text-ellipsis-2-lines" style={{ whiteSpace: 'normal' }}>
                {row?.description}
              </div>
            </KTTooltip>
          );
        },
        minWidth: '500px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Dung tích pin', 'kWh'),
        selector: (row) => (row?.batteryCapacity ? Utils.formatNumber(row?.batteryCapacity) : ''),
        right: true,
        minWidth: '150px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Loại vòi sạc'),
        selector: (row) => ChargeHelper.Utils.getChargeConnectorTypeName(row?.connectorType),
        minWidth: '150px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Loại xe'),
        selector: (row) => _.find(
          ChargeHelper.Data.vehicleTypeOptions,
          (item) => item.value === row?.vehicleType
        )?.name ?? ''
        ,
        minWidth: '100px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        width: '110px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, [isAdmin]);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    if (isAdmin) {
      // xem chi tiet
      // actions.push({
      //   text: 'Xem chi tiết',
      //   iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
      //   click: () => {
      //     handleAddNew(row);
      //   },
      // });
      // chinh sua
      actions.push({
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          handleAddNew(row);
        },
      });
      // xoa
      actions.push({
        text: 'Xoá',
        iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          handleDelete(row);
        },
      });
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeVehicleModelList });
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.VehicleModel.showDialogConfirmDeleteVehicleModel(
      chargeVehicleBrandId,
      row,
      () => {
        handleRefresh();
      }
    );
  };
  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa dòng xe' : 'Thêm dòng xe',
      <DialogAddVehicleModelView
        item={row}
        chargeVehicleBrandId={chargeVehicleBrandId}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'lg',
      false,
      true
    );
  };

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách hãng xe',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết hãng xe' },
        ])}
      </div>
      <div className="px-4 my-4">
        {UIHelper.buildCard(
          <div>
            {/* header */}
            {showFullUI && (
              <div className="px-4 pt-4 d-flex justify-content-between align-items-center">
                {/* title */}
                <div className="d-flex align-items-center gap-2">
                  {UIHelper.buildAvatar(
                    chargeVehicleBrandDetail?.logo
                      ? Utils.getFullUrl(chargeVehicleBrandDetail?.logo)
                      : null,
                    44,
                    AppResource.images.chargeConnectorTypes.imgBrandLogoDefault,
                    false,
                    false
                  )}
                  <div className="d-flex flex-column align-items-start">
                    <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                      Hãng xe: {chargeVehicleBrandDetail?.name}
                    </span>
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                      Tổng số:{' '}
                      <span style={{ color: AppColors.primary }}>
                        {Utils.formatNumber(total)} dòng xe
                      </span>
                    </span>
                  </div>
                </div>

                {/* actions */}
                {isAdmin &&
                  UIHelper.buildGreenButton(
                    'Thêm mới',
                    handleAddNew,
                    <i className="fa-regular fa-circle-plus" />
                  )}
              </div>
            )}
            {/* body */}
            <div className={`${showFullUI ? 'p-4' : 'pt-4'}`}>
              {/* filter */}
              <div className="row m-0">
                {/* tim kiem */}
                <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo tên dòng xe, mô tả..."
                    value={ChargeHelper.Filter.chargeVehicleModelList.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeVehicleModelList = {
                        ...ChargeHelper.Filter.chargeVehicleModelList,
                        page: 0,
                        q: text,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              </div>

              {/* table */}
              <div className="mb-3">
                <KTTable
                  columns={fullColumns}
                  items={chargeVehicleModelList}
                  selectableRows={false}
                  striped={false}
                  compactGrid={false}
                  onClickedRow={(row) => { }}
                  onSelectedRowsChanged={(rows) => { }}
                  onDoubleClickedRow={(row) => { }}
                  noDataComponent={UIHelper.buildEmptyNoData(
                    'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                  )}
                />
              </div>

              {/* phan trang */}
              <KTPagination
                currentPage={filter.page + 1}
                rowCount={total}
                rowsPerPage={filter.limit}
                currentItemInPageCount={chargeVehicleModelList?.length}
                onChangePage={(newPage) => {
                  const iNewPage = parseInt(newPage);
                  ChargeHelper.Filter.chargeVehicleModelList = {
                    ...ChargeHelper.Filter.chargeVehicleModelList,
                    page: iNewPage - 1,
                  };
                  handleRefresh();
                }}
                onChangeRowsPerPage={(newRowsPerPage) => {
                  const iNewRowsPerPage = parseInt(newRowsPerPage);
                  ChargeHelper.Filter.chargeVehicleModelList = {
                    ...ChargeHelper.Filter.chargeVehicleModelList,
                    limit: iNewRowsPerPage,
                    page: 0,
                  };
                  handleRefresh();
                }}
                loading={isLoading}
                color={KTPaginationColor.success}
                appendText="dòng xe"
              />
            </div>
          </div>,
          false,
          !showFullUI
        )}
      </div>
    </div>
  );
}

export default ChargeVehicleModelListView;
